import { render, staticRenderFns } from "./expenseType.vue?vue&type=template&id=37feb61e&scoped=true"
import script from "./expenseType.vue?vue&type=script&lang=ts"
export * from "./expenseType.vue?vue&type=script&lang=ts"
import style0 from "./expenseType.vue?vue&type=style&index=0&id=37feb61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37feb61e",
  null
  
)

export default component.exports